import useClientState from '@/state/useClientState';

/**
 * Custom hook voor het consumeren van signalen.
 * In de clientState worden deze platgeslagen naar een lijst van `Signaal` signalen.
 * De meta-informatie van het bericht zijn hierin al opgenomen via de properties tijdstip, actor en correlatieId.
 */
const useSignalen = () => {
  const signalenView = useClientState((state) => state.signalen);
  return { signalenView };
};
export default useSignalen;
